export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7749.2a0fec17.jpg";